import {ReactElement} from 'react'
import {Trans, WithNamespaces, withNamespaces} from 'react-i18next'

import messages from '../../../../../assets/messages'
import UiNotification from '../../../../Common/UiNotification'

type SuccessSubmitModalProps = WithNamespaces & {
  isOpen: boolean,
  onClose: () => void,
}

function SuccessSubmitModalBase(props: SuccessSubmitModalProps): ReactElement {
  const {isOpen, onClose, t} = props

  return (
    <UiNotification
      open={isOpen}
      status="success"
      type="payment"
      buttonMessage={t(messages.close.i18nKey, messages.close.defaults)}
      onClose={onClose}
    >
      <Trans {...messages.withdrawalRequestsSuccessfullySubmitted} />
    </UiNotification>
  )
}

const SuccessSubmitModal = withNamespaces()(SuccessSubmitModalBase)

export {SuccessSubmitModal}
